import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a3650f5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "closefriend-hero background-white" }
const _hoisted_2 = { class: "container mt-5" }
const _hoisted_3 = {
  method: "POST",
  action: "/",
  class: "my-1"
}
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3" }
const _hoisted_6 = { class: "login-card" }
const _hoisted_7 = { class: "login-body" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = {
  class: "col-md-12 col-12",
  "data-v-fae5bece": ""
}
const _hoisted_10 = {
  "data-v-fae5bece": "",
  style: {"font-size":"2rem","font-weight":"700","letter-spacing":"0.1rem"}
}
const _hoisted_11 = { class: "form-group mt-1 mb-0" }
const _hoisted_12 = { class: "errorMsg danger ml-2" }
const _hoisted_13 = { class: "col-12 col-sm-10 offset-sm-1 col-md-6 offset-md-3 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3" }
const _hoisted_14 = { class: "row justify-content-center mx-md-0 mx-1 mb-1 mt-0" }
const _hoisted_15 = { class: "col-md-12 col-12 px-1" }
const _hoisted_16 = { class: "text-muted text-right" }
const _hoisted_17 = {
  class: "modal fade",
  id: "exampleModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_18 = { class: "modal-dialog" }
const _hoisted_19 = { class: "modal-content" }
const _hoisted_20 = { class: "modal-header" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", {
  class: "modal-title",
  id: "exampleModalLabel"
}, "Please fix this", -1))
const _hoisted_22 = { class: "modal-body" }
const _hoisted_23 = {
  key: 0,
  ref: "errorBlock",
  id: "errorBlock"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_basic = _resolveComponent("basic")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_toast = _resolveComponent("toast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_basic),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("p", _hoisted_10, " Upload your " + _toDisplayString(_ctx.doc_name) + " ! ", 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("input", {
                      onChange: _cache[0] || (_cache[0] = ($event: any) => {_ctx.fetch_file($event);this.doc_file_error='';}),
                      id: "doc_file",
                      type: "file",
                      class: "form-control selected-field",
                      name: "doc_file",
                      required: ""
                    }, null, 32),
                    _createElementVNode("small", _hoisted_12, _toDisplayString(_ctx.doc_file_error), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    (typeof _ctx.local_storage['access-token']=='undefined' || _ctx.local_storage['access-token']==null)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          class: "success",
                          to: "/sign-in",
                          style: {"color":"#333","font-size":"0.9rem"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Sign In ? ")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("button", {
                    id: "subBtn",
                    type: "button",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args))),
                    class: "btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                  }, " Upload Now ")
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeModal('exampleModal'))),
              class: "btn btn-secondary",
              "data-mdb-dismiss": "modal"
            }, " Close ")
          ]),
          _createElementVNode("div", _hoisted_22, [
            (_ctx.errors.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, key) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: key,
                      class: "alert alert-danger"
                    }, _toDisplayString(error), 1))
                  }), 128))
                ], 512))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode(_component_toast, { ref: "toast" }, null, 512)
  ], 64))
}